export { default as Report } from './page';


// WEBPACK FOOTER //
// ./src/pages/report/index.js